import React from "react";
import { DogApi } from "../../api";
import { useApiService } from "../useApiService";

export function useDogValidators() {
  const dogApi = useApiService(DogApi);

  const dogAlive = React.useCallback(
    async (dogId: number) => {
      const res = await dogApi.isDogDeceased(dogId);
      return !res.value;
    },
    [dogApi]
  );

  const dogNotExcluded = React.useCallback(
    async (dogId: number) => {
      const result = await dogApi.isDogExcluded(dogId);
      return !result.value;
    },
    [dogApi]
  );

  return { dogAlive, dogNotExcluded };
}
